import React from 'react';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import CountUp from 'react-countup';
import cx from 'classnames';

import styles from './Cards.module.css';

const Info = ({ data, country }) => {
  if(country) {
    if(data["countrySummary"]) {
      var NewConfirmed = data["countrySummary"]["newConfirmed"];
      var TotalConfirmed = data["countrySummary"]["totalConfirmed"];
      var NewDeaths = data["countrySummary"]["newDeaths"];
      var TotalDeaths = data["countrySummary"]["totalDeaths"];
      var NewRecovered = data["countrySummary"]["newRecovered"];
      var TotalRecovered = data["countrySummary"]["totalRecovered"];
      var date = data["countrySummary"]["date"];
    }
    //console.log("data to cards " + TotalConfirmed + " , " + TotalRecovered + " , " + TotalDeaths)
  } else {
    NewConfirmed = data["NewConfirmed"];
    TotalConfirmed = data["TotalConfirmed"];
    NewDeaths = data["NewDeaths"];
    TotalDeaths = data["TotalDeaths"];
    NewRecovered = data["NewRecovered"];
    TotalRecovered = data["TotalRecovered"];
    date = data["date"];
  }

  if (!TotalConfirmed) {
    return (
      <div>
        <br />
        <div className={styles.loading}>Loading...</div>
        <br />
      </div>
    );
  }

  return (
    <div>
      <div className={styles.container}>
      <Grid container spacing={3} justify="center">
        <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.topCards)}>
          <CardContent>
            <Typography color="primary" variant="h5" component="h2" gutterBottom >
              <center>Total Infected</center>
            </Typography>
            <Typography variant="h5" component="h3">
              <center><CountUp start={0} end={TotalConfirmed} duration={2.75} separator="," /></center>
            </Typography>
            <Typography color="textSecondary">
              <center>(Latest updated : {new Date(date).toDateString()})</center>
            </Typography>
          </CardContent>
        </Grid>
        <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.topCards)}>
          <CardContent>
            <Typography color="primary" variant="h5" component="h2" gutterBottom>
              <center>Total Recovered</center>
            </Typography>
            <Typography variant="h5" component="h3">
              <center><CountUp start={0} end={TotalRecovered} duration={2.75} separator="," /></center>
            </Typography>
            <Typography color="textSecondary">
              <center>(Latest updated : {new Date(date).toDateString()})</center>
            </Typography>
          </CardContent>
        </Grid>
        <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.topCards)}>
          <CardContent>
            <Typography color="primary" variant="h5" component="h2" gutterBottom>
              <center>Total Deaths</center>
            </Typography>
            <Typography variant="h5" component="h3">
              <center><CountUp start={0} end={TotalDeaths} duration={2.75} separator="," /></center>
            </Typography>
            <Typography color="textSecondary">
              <center>(Latest updated : {new Date(date).toDateString()})</center>
            </Typography>
          </CardContent>
        </Grid>
        <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.bottomCards)}>
          <CardContent>
            <Typography color="primary" variant="h5" component="h2" gutterBottom>
            <center>New Active cases</center>
            </Typography>
            <Typography variant="h5" component="h3">
            <center><CountUp start={0} end={NewConfirmed} duration={2.75} separator="," /></center>
            </Typography>
            <Typography color="textSecondary">
            <center>(Latest updated : {new Date(date).toDateString()})</center>
            </Typography>
          </CardContent>
        </Grid>
        <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.bottomCards)}>
          <CardContent>
            <Typography color="primary" variant="h5" component="h2" gutterBottom>
            <center>New Recoveries</center>
            </Typography>
            <Typography variant="h5" component="h3">
            <center><CountUp start={0} end={NewRecovered} duration={2.75} separator="," /></center>
            </Typography>
            <Typography color="textSecondary">
            <center>(Latest updated : {new Date(date).toDateString()})</center>
            </Typography>
          </CardContent>
        </Grid>
        <Grid item xs={12} md={3} component={Card} className={cx(styles.card, styles.bottomCards)}>
          <CardContent>
            <Typography color="primary" variant="h5" component="h2" gutterBottom>
            <center>New Deaths</center>
            </Typography>
            <Typography variant="h5" component="h3">
            <center><CountUp start={0} end={NewDeaths} duration={2.75} separator="," /></center>
            </Typography>
            <Typography color="textSecondary">
            <center>(Latest updated : {new Date(date).toDateString()})</center>
            </Typography>
          </CardContent>
        </Grid>
      </Grid>
    </div>
    <h4 className={styles.note}>(Note: The counts for new cases are within the last 24 hours.)</h4>
    </div>
  );
};
export default Info;
